<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div style="width: 800px;">  <el-button type="danger" icon="el-icon-orange"   style="margin-top:10px;" @click="get_user_ys">刷新</el-button> </div>

    <el-tabs v-model="activeName" type="card"  style="padding: 40px; width: 800px;">
        <el-tab-pane label="海康萤石云账号绑定配置" style="padding: 20px;" name="first">海康萤石云账号绑定配置


            <el-input style="margin-top: 10px;"  placeholder="萤石云APP ID" v-model="ysappid">
              <template slot="prepend">APPuser ID:</template>
            </el-input>
            <el-input style="margin-top: 10px;"   placeholder="萤石云APP Secret" show-password  v-model="ysappsecret">
              <template slot="prepend">APP Secret:</template>
            </el-input>
            <el-input placeholder="萤石云APPToken"  style="margin-top: 10px;"  show-password  v-model="ysapptoken">
              <template slot="prepend"   style="margin-top:10px;"  >APP -Token:</template>
            </el-input>

              <el-button type="success" icon="el-icon-orange"    style="margin-top:10px;" @click="Save_ys">绑定</el-button>
              <el-button type="danger" icon="el-icon-orange"     style="margin-top:10px;" @click="delete_ys">解除绑定</el-button>

        </el-tab-pane>


        <el-tab-pane label="大华乐橙云账号绑定配置"   style="padding: 20px;" name="second">大华乐橙云账号绑定配置
            <el-input style="margin-top: 10px;"  placeholder="乐橙AppId" v-model="lcappid">
              <template slot="prepend">APPuser ID:</template>
            </el-input>
            <el-input style="margin-top: 10px;"   placeholder="乐橙云APPSecret"  show-password  v-model="lcappsecret">
              <template slot="prepend">APP Secret:</template>
            </el-input>
            <el-input placeholder="乐橙APP用户名"  style="margin-top: 10px;"   v-model="lcappusername">
              <template slot="prepend"   style="margin-top:10px;"  >imoulife 账号:</template>
            </el-input>
            <el-input placeholder="乐橙APP登录密码"  style="margin-top: 10px;" show-password  v-model="lcapppasswd">
              <template slot="prepend"   style="margin-top:10px;"  >imoulife 密码:</template>
            </el-input>
              <el-button type="success" icon="el-icon-orange"     style="margin-top:10px;" @click="Save_lc">绑定</el-button>
              <el-button type="danger" icon="el-icon-orange"      style="margin-top:10px;" @click="delete_lc">解除绑定</el-button>

        </el-tab-pane>
    </el-tabs>





  </div>


</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading:false,
      setys:false,
      setlc:false,
      loadingfo:false,
      ysbackdata:[],
      lcbackdata:[],
      ysapptoken:"",
      ysappsecret:"",
      ysappid:"",
      lcappid:"",
      lcappsecret:"",
      lcappusername:"",
      lcapppasswd:"",
      activeName: 'first'
    };
  },
  created(){
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
    //this.get_user_ys();

  },
  methods: {

    delete_lc(){
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
          this.loadingfo = true;

          this.lcappid = "";
          this.lcappsecret ="";
          this.lcappusername ="";
          this.lcapppasswd ="";
          axios.get("/delete_lc.php", {
              params: {
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {

                  this.$notify.success({
                    title: "Info",
                    message: "已加载",
                    showClose: false
                  });

                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "监控平台还没绑定...",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            })
              this.get_user_ys();

    },
    delete_ys(){
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      this.loadingfo = true;
          axios.get("/delete_ys.php", {
              params: {
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.ysappsecret ="";
                  this.ysappid = "";
                  this.ysapptoken = "";
                  this.$notify.success({
                    title: "Info",
                    message: "已加载",
                    showClose: false
                  });

                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "监控平台还没绑定...",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            })

        this.get_user_ys();
    },
    get_user_ys(){
          let username = sessionStorage.getItem("username");
          let passwd = sessionStorage.getItem("passwd");
          axios.get("/get_user_ys.php", {
              params: {
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.setys =  res.data.isys;
                  this.setlc =  res.data.islc;
                  if(this.setlc){
                    this.lcbackdata  = res.data.lc;
                    this.lcappid = res.data.lc.appkey;
                    this.lcappsecret = res.data.lc.appSecret;
                    this.lcappusername = res.data.lc.username;
                    this.lcapppasswd = res.data.lc.passwd;
                  }
                  if(this.setys){
                    this.ysbackdata  = res.data.ys;
                    this.ysappsecret = res.data.ys.appSecret;
                    this.ysappid = res.data.ys.appkey;
                    this.ysapptoken = res.data.ys.apptoken;
                  }
                  this.$notify.success({
                    title: "Info",
                    message: "已加载",
                    showClose: false
                  });
                } else {
                  this.setys  = false;
                  this.setlc  = false;
                  this.$notify.success({
                    title: "Info",
                    message: "监控平台还没绑定...",
                    showClose: false
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            })

            this.loadingfo = false;

         }
    ,

    Save_lc(){
      this.loadingfo = true;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      if(this.lcappusername.length  < 5){
        console.log(this.lcappusername.length);
          return;
      }
      if(this.lcapppasswd.length  < 6){
        console.log(this.lcapppasswd.length);
          return;
      }
      if(this.lcappid.length  < 10){
          console.log(this.lcappid.length);
          return;
      }
      if(this.lcappsecret.length  < 10){
          console.log(this.lcappsecret.length);
          return;
      }
          axios.get("/savelc.php", {
              params: {
                lcapppasswd: this.lcapppasswd,
                lcappusername: this.lcappusername,
                lcappid: this.lcappid,
                lcappsecret: this.lcappsecret,
                username: username,
                passwd: passwd
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  this.$notify.success({
                    title: "Info",
                    message: "修改成功",
                    showClose: false
                  });

                } else {
                  this.$notify.success({
                    title: "Info",
                    message: "修改失败",
                    showClose: false
                  });
                }

              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            })
              this.get_user_ys();
         }
    ,
  Save_ys(){
    this.loadingfo = true;
      console.log(this.ysapptoken.length);
    let username = sessionStorage.getItem("username");
    let passwd = sessionStorage.getItem("passwd");
    if(this.ysapptoken.length  < 30){
      console.log(this.ysapptoken.length);
        return;
    }
    if(this.ysappsecret.length  < 32){
      console.log(this.ysapptoken.length);
        return;
    }
    if(this.ysappid.length  < 30){
        console.log(this.ysappid.length);
        return;
    }
        axios.get("/saveys.php", {
            params: {
              ysapptoken: this.ysapptoken,
              ysappsecret: this.ysappsecret,
              ysappid: this.ysappid,
              username: username,
              passwd: passwd
            }
          })
          .then(
            function(res) {
              if (res.data.res) {

                this.$notify.success({
                  title: "Info",
                  message: "修改成功",
                  showClose: false
                });
              } else {
                this.$notify.success({
                  title: "Info",
                  message: "修改失败",
                  showClose: false
                });
              }

            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          })
         this.get_user_ys();
       }
  }
};
</script>

<style   scoped>
#devmg {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px ;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.edit_dev  {
	text-align:left ;
	/deep/ .el-transfer-panel {
		width:300px;
	}
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/gis_Mg.vue